// extracted by mini-css-extract-plugin
module.exports = {"button":"outline-module--button--1U0OJ","disabled":"outline-module--disabled--2HQch"};